const TEST_LOGIN = 'test-login';
const ORG_ID = 'orgId';
const ORG_LIST = 'org-list';
const OPTION_YEAR = 'optionYear';
const APPLICATION = 'application';
const YEARS = 'years';
const HAS_ROLE = 'has-role';
const ACTIVE_YEARS_TYPES = 'active-years-types';
const S3_ACTIVE = 's3-active';
const HELP_CONTENT = 'help-content';
const APPLICATION_DISPLAY = 'app-display';
const CLIENT_TYPES_DATA = 'clientTypesData';
const CHECKED_ACTIVE_YEARS = 'checkedActiveYears';
const TERMS_DATA = 'termsData';
const OPTION_SET_ID = 'optionSetId';
const BASIC_PROFILE = 'basicProfile';
const DELETED_ROWS = 'deletedRows';

export default {
  TEST_LOGIN,
  ORG_ID,
  ORG_LIST,
  OPTION_YEAR,
  APPLICATION,
  YEARS,
  HAS_ROLE,
  ACTIVE_YEARS_TYPES,
  S3_ACTIVE,
  HELP_CONTENT,
  APPLICATION_DISPLAY,
  CLIENT_TYPES_DATA,
  CHECKED_ACTIVE_YEARS,
  TERMS_DATA,
  OPTION_SET_ID,
  BASIC_PROFILE,
  DELETED_ROWS,
};
